import {Box} from "@mui/material";
import './CreateDocument.scss';
import React, {useEffect, useState} from "react";
import CreateDocumentStep1 from "./CreateDocumentStep1";
import CreateDocumentStep2 from "./CreateDocumentStep2";
import CreateDocumentStep3 from "./CreateDocumentStep3";
import {useLocation} from "react-router-dom";


interface GeneratedDocument {
    signature: string;
    receiverName: string;
    receiverAddress: string;
    inbox: boolean;
    emailFilled: boolean;
    sending: boolean;
    sent: boolean;
    sendingWithEmail: boolean;
}

export default function CreateDocument() {

    const location = useLocation();
    const [step, setStep] = useState(location.state?.replyTo ? 2 : 1)
    const [documentTypeCode, setDocumentTypeCode] = useState<Number>(location.state?.replyTo ? 301 : 0)
    const [signature, setSignature] = useState("")
    const [generatedDocuments, setGeneratedDocuments] = useState<GeneratedDocument[]>([])

    useEffect(() => {
        if (location.state?.replyTo) {
            setDocumentTypeCode(301);
            setStep(2);
        }
    }, [location.state]);

    let step1Callback = (code : Number) => {
        if(code != null) {
            setDocumentTypeCode(code);
            setStep(2);
        }
    }

    let step2Callback = (documents : GeneratedDocument[]) => {
        if(documents != null) {
            setGeneratedDocuments(documents);
            setStep(3);
        }
    }

    const handleDocumentChange = (signature: string, newDoc: GeneratedDocument) => {
        setGeneratedDocuments(prevDocuments =>
            prevDocuments.map(doc =>
                doc.signature === signature
                    ? newDoc
                    : doc
            )
        );
    };


    return (
        <Box className="GenerateDocument">
            {step == 1 && <CreateDocumentStep1 callback={step1Callback}/>}
            {step == 2 && <CreateDocumentStep2 documentTypeId={documentTypeCode} callback={step2Callback} initialReplyTo={location.state?.replyTo}/> }
            {step == 3 && <CreateDocumentStep3 documents={generatedDocuments} onDocumentChange={handleDocumentChange}/> }
        </Box>
    )
}